const Card = ({ title, children, style }) => {
    return (
      <div
        style={{
          background: "white",
          borderRadius: "10px",
          boxShadow: "0 4px 10px rgba(0,0,0,0.05)",
          padding: "20px",
          marginBottom: "20px",
          ...style,
        }}
      >
        {title && (
          <div
            style={{
              borderBottom: "1px solid #eee",
              paddingBottom: "10px",
              marginBottom: "15px",
            }}
          >
            <h3 style={{ margin: 0 }}>{title}</h3>
          </div>
        )}
        {children}
      </div>
    )
  }
  
  export default Card
  